module.exports = __webpack_public_path__ + "Roboto-Black.2a82f89b0a35ee7f9d45.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Black.eot
// module id = 33
// module chunks = 17